import { render, staticRenderFns } from "./Redletterinformationtablemanagement.vue?vue&type=template&id=3449b664&scoped=true&"
import script from "./Redletterinformationtablemanagement.vue?vue&type=script&lang=js&"
export * from "./Redletterinformationtablemanagement.vue?vue&type=script&lang=js&"
import style0 from "./Redletterinformationtablemanagement.vue?vue&type=style&index=0&id=3449b664&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3449b664",
  null
  
)

export default component.exports